export default {
  titelList: [
    "Dipl.-Ing.",
    "Dr.",
    "Prof.",
    "Prof. Dr.",
    "B.A.",
    "B.Sc.",
    "B.Eng.",
    "B.F.A.",
    "B.Mus.",
    "B.Ed.",
    "Dipl.",
    "Dipl.(FH)",
    "Dipl.-Betriebsw",
    "Dipl.-Biol.",
    "Dipl.-Finw.",
    "Dipl.-Inform.",
    "Dipl.-Ing.",
    "Dipl.-Kfm.",
    "Dipl.Oec.",
    "Dipl.-Päd.",
    "Dipl.-Verww.",
    "Dipl.-Volksw.",
    "Dr.",
    "Dr.Dr.",
    "Dr.h.c.",
    "Dr.Ing.",
    "Dr.jur.",
    "Dr.med.",
    "Dr.med.dent.",
    "Dr.med.vet.",
    "Dr.oec.",
    "Dr.phil.",
    "Dr.rer.nat.",
    "LL.B.",
    "LL.M.",
    "M.A",
    "M.Ed.",
    "M.Eng.",
    "M.F.A.",
    "M.Sc.",
    "M.Mus.",
    "Prof.",
    "Prof.Dr.",
    "Prof.Dr.Dr.",
    "Baron",
    "Baronin",
    "Erzherzog",
    "Erzherzogin",
    "Freiherr",
    "Freifrau",
    "Fürst",
    "Fürstin",
    "Graf",
    "Gräfin",
    "Großfürst",
    "Großfürstin",
    "Großherzogin",
    "Großherzog",
    "Herzog",
    "Herzogin",
    "Kaiser",
    "Kaiserin",
    "König",
    "Königin"
  ]
};
